import { UsersService } from '@shared/services/users/users.service';
import {
  Component,
  OnInit,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  LOCALE_ID,
  Inject
} from '@angular/core';
import { StandService } from 'app/stand/stand.service';
import { QueryRef } from 'apollo-angular';
import { ActivatedRoute, Router } from '@angular/router';
import { INews } from '@collections/news/interfaces/news.interface';
import { UserRolesEnum } from '@collections/users/enums/user-roles.enums';
import { NewsGQL, NewsResponse } from '@shared/services/news/news.gql.service';
import { NewsStatusEnum, NewsTypeEnum } from '@collections/news/enums/news.enums';
import { StandLayoutEnum } from '../../stand.enums';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SoftDeleteNewsGQL } from '@shared/services/news/news-soft-delete.gql.service';
import { ICompany } from '@collections/companies/interfaces/company.interface';
import { RobotsIndexEnum } from 'app/shared/services/meta-data-service/meta-data.commons';
import { CardEditBarComponent } from '../../../shared/components/card-edit-bar/card-edit-bar.component';
import { NewsBlockComponent } from '../../../news/views/news-block/news-block.component';
import { PagedVirtualScrollerComponent } from '../../../shared/components/paged-virtual-scroller/paged-virtual-scroller.component';
import { MatIcon } from '@angular/material/icon';
import { MatFabButton } from '@angular/material/button';
import { RenderIfDirective } from '../../../shared/directives/render-if.directive';
@UntilDestroy()
@Component({
    selector: 'stand-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        RenderIfDirective,
        MatFabButton,
        MatIcon,
        PagedVirtualScrollerComponent,
        NewsBlockComponent,
        CardEditBarComponent,
    ],
})
export class NewsComponent implements OnInit {
  newsQuery: QueryRef<NewsResponse>;
  UserRolesEnum = UserRolesEnum;
  newsStatusEnum = NewsStatusEnum;
  isAdimin = false;
  company: ICompany;

  constructor(
    private standService: StandService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    @Inject(LOCALE_ID) private lang: string,
    private newsGql: NewsGQL,
    private softDeleteNewsGQL: SoftDeleteNewsGQL,
    private userService: UsersService
  ) {

  }

  ngOnInit(): void {
    this.isAdimin = this.userService.isInRole([UserRolesEnum.admin, UserRolesEnum.stand_admin]);

    this.standService.getCurrentCompany()
    .pipe(untilDestroyed(this))
    .subscribe( company => {
      this.company = company;
      this.newsQuery = this.newsGql.watch({
        newsType: NewsTypeEnum.companies,
        newsStatus: this.isAdimin ? NewsStatusEnum.all : NewsStatusEnum.companyLevelValidated,
        unpublished: this.isAdimin,
        companyId: company._id,
        lang: this.standService.currentLanguageCode,
        first: 16
      });
      //  tracking page on analytics browser side and metadata server-side
      const canonical = {...this.standService.canonicalDefaultUrl};
      canonical.path = canonical.path + '/news';
      this.standService.appendCompanyMetaTags(canonical, null, RobotsIndexEnum.noindex_follow);
    });
  }

  editNews(item: INews): void {
    this.router.navigate(['../', 'edit', 'news', this.company._id, this.lang, item._id], { relativeTo: this.activatedRoute });
  }

  addNews(): void {
    this.router.navigate(['../', 'edit', 'news', this.company._id, this.lang ], { relativeTo: this.activatedRoute });
  }

  deleteNews(item: INews): void {
    this.softDeleteNewsGQL.mutate({
      companyId: this.company._id,
      id: item._id
    }, {
      update(cache): void {
        cache.evict({
          id: `News:${item._id}`
        });
        cache.gc();
      }
    })
    .subscribe();
  }
}
